import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { initializeAutosave } from "./actions";

const OnHoldModal = ({ showOnHoldModal, closeOnHoldModal, ...props }) => {
  const history = useHistory();
  const dashboardFilter = localStorage.getItem("dashboardFilters");
  return (
    <>
      {showOnHoldModal && (
        <Modal show={showOnHoldModal} onHide={closeOnHoldModal} centered>
          <Modal.Body
            className="px-sm-3 px-lg-5 px-3"
            style={{ maxWidth: "570px" }}
          >
            <div className="py-4 px-sm-0 px-lg-5 px-0">
              <div className="text-center mt-3">
                <h4 className="px-2" style={{ color: "1B2027" }}>
                  <b>Are you sure you want to put this call on Hold?</b>
                </h4>
                <div className="container p-2 text-center">
                  <div>
                    <p style={{ fontSize: "18px" }}>
                      If you put this call on hold you can rejoin the call from
                      Dashboard
                    </p>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row justify-content-around ">
                  <div className="col-sm-12 col-md-6  mb-sm-2 text-center">
                    <Button
                      className="btn btn-lg border-0 mb-md-2  border rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#17BAE0", color: "#fff" }}
                      onClick={() => {
                        props.dispatchInitializeAutoSave();
                        props.clearIntervals();
                        if (
                          window?.location?.pathname &&
                          window?.location?.pathname?.includes("clinic")
                        ) {
                          history.push(
                            `/clinic/account/dashboard${
                              dashboardFilter && `?` + dashboardFilter
                            }`
                          );
                        } else {
                          history.push("/doctor/account/dashboard");
                        }
                      }}
                    >
                      Yes
                    </Button>
                  </div>

                  <div className="col-sm-12 col-md-6  text-center">
                    <Button
                      className="btn btn-lg border   rounded-pill coupon-confirm-button"
                      style={{ backgroundColor: "#fff", color: "#17BAE0" }}
                      onClick={closeOnHoldModal}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export function mapDispatchToProps(dispatch) {
  return {
    dispatchInitializeAutoSave: () => dispatch(initializeAutosave()),
  };
}
export default connect(null, mapDispatchToProps)(OnHoldModal);
